import { maxWidth, noTouch, minWidth } from '@/assets/styles/mixins.css.js';
import styled, { css } from 'styled-components';
import vars from '@/assets/styles/vars';

const PartitionCard = styled.div`
  position: relative;
  z-index: 1;
  line-height: 1.16;
  user-select: none;
  height: 100%;

  &:hover {
    z-index: 2;
  }

  ${(props) =>
    props.cardForm === 'square' &&
    css`
      --card-height: 80%;

      ${maxWidth(vars.breakpoints.tablet)`
        --card-height: 50%;
      `}
    `}

  ${(props) =>
    props.cardImage === 'none' &&
    css`
      --card-tag-color: var(--color-extra);
      --card-tag-hover-color: var(--color-decor-dark);
      --card-title-color: var(--color-main);
      --card-desc-color: var(--color-extra);
      --card-bg-color: #fff;
      --card-bg-opacity: 1;
      --card-bg-hover-opacity: 1;
      --card-bg-outline: var(--color-border);
      --card-arrow-mobile-color: var(--color-decor);
    `}

  ${(props) =>
    props.type === 'service' &&
    css`
      ${PartitionCard.Title} {
        display:block;
      }
    `}

  ${({ cardType }) => {
    switch (cardType) {
      case 'content':
        return css`
          --card-font-size: 20px;
          --card-title-lines: 2;

          ${maxWidth(1150)`
            --card-font-size: 18px;

            ${PartitionCard.Content} {
              padding-top: 26px;
            }
          `}

          ${PartitionCard.Bg} {
            &::after {
              min-height: 140px;
            }
          }

          ${PartitionCard.Tag} {
            display: none;
          }
        `;
      default:
        return css`
          ${maxWidth(vars.breakpoints.xsDesktop)`
            --card-title-lines: 2;
            --card-font-size: 20px;
          `}

          ${maxWidth(vars.breakpoints.mTablet)`
            --card-title-lines: 2;
            --card-font-size: 18px;
          `}
        `;
    }
  }}

  ${({ theme }) => {
    switch (theme) {
      case 'light1':
        return css`
          --card-bg-color: linear-gradient(180deg, rgba(255, 255, 255, 0) 25%, rgba(255, 255, 255, 0.8) 100%);
          --card-bg-opacity: 1;
          --card-bg-hover-opacity: 1;
          --card-title-color: var(--color-main);
          --card-desc-color: var(--color-extra);
          --card-arrow-mobile-color: var(--color-decor);

          ${PartitionCard.Bg} {
            img {
              z-index: -1;
            }
          }
        `;
      default:
        return;
    }
  }}

  ${(props) =>
    props.cardType === 'specialist' &&
    css`
      --card-tag-color: var(--color-extra);
      --card-tag-hover-color: var(--color-decor);
      --card-title-color: var(--color-decor);
      --card-desc-color: #757575;
      --card-arrow-mobile-color: var(--color-decor);
      --card-bg-color: #f8f8f8;
      --card-bg-opacity: 1;
      --card-bg-hover-opacity: 1;
      min-height: 100%;

      ${PartitionCard.Content} {
        padding: 45px;
      }

      ${PartitionCard.Title}, ${PartitionCard.Desc} {
        max-width: 50%;
        margin: 0;
        text-transform: unset;
        transform: unset;
        opacity: 1;
      }

      ${PartitionCard.Text} {
        max-width: 50%;
      }

      ${PartitionCard.Bg} {
        height: 327px;
        &:after {
          padding: 0;
        }
        img {
          object-fit: contain;
          object-position: 100% 100%;
        }
      }

      ${maxWidth(vars.breakpoints.tablet)`
        ${PartitionCard.Content} {
          padding: 15px 0 0;
          position:static;
        }
        ${PartitionCard.Bg} {
          height: 305px;
          transform:none !important;
          &:before {
            box-shadow:none;
          }
        }
        ${PartitionCard.Title}, ${PartitionCard.Desc},${PartitionCard.Text}  {
          display; block;
          max-width: 100%;
        }
        ${PartitionCard.Title} {
          font-size: 28px;
        }
      `}
    `}

  ${(props) =>
    props.cardType === 'link' &&
    css`
      --card-bg-color: var(--color-decor);
      --card-bg-hover-opacity: 1;
      --card-arrow-bg-color: #fff;
      --card-arrow-color: var(--color-decor);
      --card-title-color: #fff;
      --card-desc-color: rgba(255, 255, 255, 0.8);
      --card-arrow-mobile-color: #fff;

      ${PartitionCard.Bg} {
        box-shadow: none;
      }

      ${PartitionCard.Content} {
        padding-top: 30px;

        ${maxWidth(vars.breakpoints.mTablet)`
          padding-top: 22px;
        `}
      }

      ${PartitionCard.Title} {
        margin-top: 0;
        margin-bottom: auto;
        padding-right: 44px;
        transform: none;
      }

      ${PartitionCard.Desc} {
        transform: none;
        opacity: 1;
      }

      ${maxWidth(vars.breakpoints.tablet)`
        height: 100%;

        ${PartitionCard.Arrow} {
          top: 28px;
        }

        ${PartitionCard.Bg} {
          height: 100%;

          &::after {
            min-height: 100%;
          }
        }
      `}

      ${maxWidth(vars.breakpoints.mTablet)`
        ${PartitionCard.Arrow} {
          top: 16px;
        }
      `}

      ${maxWidth(vars.breakpoints.lMobile)`
        height: auto;
        margin-top: 24px;
        border-radius: 32px;
        overflow: hidden;

        ${PartitionCard.Bg} {
          height: auto;
          transform: none !important;

          &::after {
            height: 48px;
            padding-top: 0;
          }
        }

        ${PartitionCard.Content} {
          padding: 0;
          justify-content: center;
          align-items: center;
        }

        ${PartitionCard.Title} {
          margin-bottom: 0;
          padding-right: 0;
          font-size: 14px;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: 0.02em;
        }

        ${PartitionCard.Desc} {
          display: none;
        }

        ${PartitionCard.Arrow} {
          display: none;
        }
      `}
    `}
`;

PartitionCard.Bg = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: #fff;
  transition: transform 0.3s ease-in;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    padding-top: var(--card-height, 40%);
    background: var(--card-bg-color, rgba(0, 0, 0, 0.5));
    opacity: var(--card-bg-opacity, 0.5);
    transition: background 0.3s ease-in, opacity 0.3s ease-in;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.08);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease-out;
  }

  img,
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${noTouch()`
    ${PartitionCard}:hover & {
      z-index: 0;
      transform: scale(1.05);
      transition: transform 0.3s ease-out;
      box-shadow: none;

      &::after {
        opacity: var(--card-bg-hover-opacity, 0.4);
        transition: background 0.3s ease-out, opacity 0.3s ease-out;
      }

      &::before {
        opacity: 1;
      }
    }
  `}

  ${(props) =>
    props.isMobile &&
    css`
      ${maxWidth(vars.breakpoints.tablet)`
        display:none;
      `}
    `}
  ${(props) =>
    props.mobile &&
    css`
      display:none;
      ${maxWidth(vars.breakpoints.tablet)`
        display:block;
      `}
    `}
`;

PartitionCard.Arrow = styled.div`
  position: absolute;
  top: 16px;
  right: 20px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 46px;
  height: 46px;
  background: var(--color-decor);
  border-radius: 50%;
  color: var(--card-arrow-color, #fff);
  transform: rotate(180deg);
  opacity: 0;
  transition: none;

  & > svg {
    width: 20px;
    height: auto;
  }

  ${maxWidth(vars.breakpoints.tablet)`
    width: 20px;
    height: 30px;
    background: transparent;
    opacity: 1;
    color: var(--card-arrow-mobile-color, #fff);
  `}

  ${PartitionCard}:hover & {
    opacity: 1;
    transition: opacity 0.3s ease-in;
  }
`;

PartitionCard.Content = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 38px 40px;

  ${maxWidth(vars.breakpoints.mTablet)`
    padding: 25px 28px;
  `}
`;

PartitionCard.Tag = styled.p`
  flex-shrink: 0;
  display: block;
  display: -webkit-box;
  max-height: calc(12px * 1.2 * 2);
  -webkit-line-clamp: 2;
  -moz-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 12px;
  font-weight: bold;
  font-size: 12px;
  line-height: 1.2;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--card-tag-color, rgba(255, 255, 255, 0.7));
  transition: color 0.3s ease-in;

  ${maxWidth(vars.breakpoints.mTablet)`
    padding-right: 26px;
    font-size: 11px;
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    margin-bottom: 8px;
  `}

  ${PartitionCard}:hover & {
    color: var(--card-tag-hover-color, rgba(255, 255, 255, 0.7));
    transition: color 0.3s ease-out;

    ${minWidth(vars.breakpoints.tablet + 1)`
      padding-right: 44px;
    `}
  }
`;

PartitionCard.Title = styled.h3`
  flex-shrink: 0;
  display: block;
  display: -webkit-box;
  -webkit-line-clamp: var(--card-title-lines, 3);
  -moz-line-clamp: var(--card-title-lines, 3);
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: auto;
  font-weight: normal;
  font-size: 28px;
  line-height: 1.2;
  white-space: pre-wrap;
  text-transform: uppercase;
  color: var(--card-title-color, var(--color-light));
  transition: transform 0.25s 0.15s ease-in;

  ${maxWidth(vars.breakpoints.tablet)`
    font-size: 24px;
  `}

  ${minWidth(vars.breakpoints.tablet + 1)`
      transform: translateY(28px);
    
      &:last-child {
        transform: none;
      }
  `}

  ${PartitionCard}:hover & {
    transform: none;
    transition: transform 0.3s ease-out;
  }
`;

PartitionCard.Desc = styled.p`
  flex-shrink: 0;
  display: block;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -moz-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 10px;
  font-weight: normal;
  font-size: 18px;
  line-height: 1.22;
  color: var(--card-desc-color, #757575;);
  transition: transform 0.3s ease-in, opacity 0.3s ease-in;

  ${maxWidth(vars.breakpoints.tablet)`
    padding-top: 10px;
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    padding-top: 8px;
  `}

  ${minWidth(vars.breakpoints.tablet + 1)`
    opacity: 0;
    transform: translateY(28px);
  `}

  ${PartitionCard}:hover & {
    transform: none;
    opacity: 1;
    transition: transform 0.25s 0.15s ease-out, opacity 0.25s 0.15s ease-out;
  }
`;
PartitionCard.Text = styled.p`
  flex-shrink: 0;
  display: -webkit-box;
  max-height: calc(28.24px);
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 12px;
  font-weight: normal;
  font-size: 14px;
  line-height: 1.16;
  margin-top: unset;
  color: var(--card-desc-color, rgba(255, 255, 255, 0.8));
  transition: transform 0.3s ease-in, opacity 0.3s ease-in, margin 0.3s ease-in;

  ${maxWidth(vars.breakpoints.tablet)`
    padding-top: 10px;
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    padding-top: 8px;
  `}

  ${minWidth(vars.breakpoints.tablet + 1)`
    opacity: 0;
    margin-top:auto;
    margin-bottom: -28px;
  `}

  ${PartitionCard}:hover & {
    transform: none;
    opacity: 1;
    margin-bottom: 0;
    transition: transform 0.25s 0.15s ease-out, opacity 0.25s 0.15s ease-out, margin 0.25s 0.15s ease-out;
  }
`;

PartitionCard.Link = styled.a`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;

  ${PartitionCard}:hover & {
    transform: scale(1.05);
    transition: transform 0.3s ease-out;
  }
`;

export default PartitionCard;
